jQuery.noConflict();
(function( $ ) {
    $(function() {
        if ($('.sc_cookie_notification').length>0) {

            function setConsent(consent) {
                var consentModeName = $('.sc_cookie_notification').attr('data-cname'),
                    expireName = 'expire_'+consentModeName,
                    expire = $('.sc_cookie_notification').attr('data-expire');
                const consentMode = {
                    'functionality_storage': consent.necessary ? 'granted' : 'denied',
                    'security_storage': consent.necessary ? 'granted' : 'denied',
                    'ad_storage': consent.marketing ? 'granted' : 'denied',
                    'analytics_storage': consent.analytics ? 'granted' : 'denied',
                    'personalization': consent.preferences ? 'granted' : 'denied',
                    'ad_user_data': consent.marketing ? 'granted' : 'denied',
                    'ad_personalization': consent.marketing ? 'granted' : 'denied',
                };
                gtag('consent', 'update', consentMode);
                localStorage.setItem(consentModeName, JSON.stringify(consentMode));
                localStorage.setItem(expireName, expire);

                $('.sc_cookie_notification').slideToggle();
                setTimeout(function(){
                    $('.sc_cookie_notification').remove();
                }, 500);
            }

            $('.consent-option .heading strong').on('click', function(e){
                e.preventDefault();
                $(this).toggleClass('active');
                $(this).parent().parent().find('small').slideToggle();
            });

            $('.sc_cookie_notification .cookie-consent-button').on('click', function(){
                var buttonID = $(this).attr('id');
                if (buttonID == 'btn-accept-all') {
                    setConsent({
                        necessary: true,
                        analytics: true,
                        preferences: true,
                        marketing: true
                    });
                }
                else if (buttonID == 'btn-accept-some') {
                    setConsent({
                        necessary: true,
                        analytics: document.getElementById('consent-analytics').checked,
                        preferences: document.getElementById('consent-preferences').checked,
                        marketing: document.getElementById('consent-marketing').checked
                    });
                }
                else {
                    setConsent({
                        necessary: false,
                        analytics: false,
                        preferences: false,
                        marketing: false
                    });
                }
            });

            $('#manage-cookies-pref').on('click', function(e){
                e.preventDefault();
                if ($('#cookie-consent-banner .cookie-consent-options').length> 0) {
                    $('#cookie-consent-banner .cookie-consent-options').slideToggle();
                    $('.cookie-default-view').slideToggle();
                }
            });
            $('.sc_accept_all').on('click', function(){
                $('#btn-accept-all').trigger('click');
            });

            var notificarionContainer = $('.sc_cookie_notification'),
                consentModeName = notificarionContainer.attr('data-cname'),
                consentMode = localStorage.getItem(consentModeName);
            if (consentMode == null || consentMode == undefined) {
                setTimeout(function(){
                    notificarionContainer.slideToggle();
                }, 2000);
            }
            else {
                var expireName = 'expire_'+consentModeName,
                    expire = localStorage.getItem(expireName),
                    now = notificarionContainer.attr('data-now');
                if (now > expire) {
                    setTimeout(function(){
                        notificarionContainer.slideToggle();
                    }, 2000);
                }
            }
        }

    });
})(jQuery);